import { useLocation } from 'react-router'

export function useBreadcrumbs () {
  const { pathname } = useLocation()

  const pathParts = pathname.split('/').filter(Boolean)

  const breadcrumbs = pathParts.map((part, index) => {
    const path = '/' + pathParts.slice(0, index + 1).join('/')

    return {
      label:
        path === '/history'
          ? 'Lifecycle History'
          : decodeURIComponent(part)
              .replace(/-/g, ' ')
              .replace(/\b\w/g, c => c.toUpperCase())
    }
  })

  return breadcrumbs
}
